export const shopsData = [
  {
    id: '7',
    name: 'Loggy MACRAME',
    nameEn: 'Loggy MACRAME',
    category: 'Craft',
    area: '名護市',
    catchphrase: '女性オーナーが営むマクラメ専門店',
    description: '名護生まれ名護育ちのオーナー翁長さん(女性)が鉄づくりで一つ一つ丁寧に手作りされたマクラメです。オーダーも可能です。気さくで明るい翁長さんのお店には常に立ち寄るコミュニティがあります。英語での対応も可能です。',
    image: 'https://static.readdy.ai/image/6c69b51a00dc57b0005798d3c185e184/c5a2b4f4b45508a6e2572b982b2ebd50.png',
    address: '〒905-0013 沖縄県名護市城１丁目５−１７',
    hours: '12:00 - 18:00',
    closed: '不定休',
    phone: '080-6496-8624',
    website: 'https://facebook.com/loggymacrame',
    instagram: 'loggy_macrame',
    lat: 26.5929685,
    lng: 127.9772586,
    featured: true
  },
  {
    id: '8',
    name: '琉球陶器 まさひろ工房',
    nameEn: 'Ryukyu Touki Masahiro Koubou',
    category: 'Craft',
    area: '金武町',
    catchphrase: 'やちむん(陶器制作)の伝統を守る工房',
    description: '金武町で琉球の伝統的なやちむん(陶器)を制作する工房。代々受け継がれてきた技術と、沖縄の土を使った温かみのある作品が特徴です。日常使いの器から芸術作品まで、幅広い陶器を制作しています。工房見学や陶芸体験も受け付けており、琉球の伝統工芸に触れることができます。',
    image: 'https://public.readdy.ai/ai/img_res/8bb3b4afd4d85ac7606ba6005b389704.jpg',
    address: '〒904-1202 沖縄県国頭郡金武町伊芸720-1番地',
    hours: '09:00 - 17:00',
    closed: '不定休',
    phone: '070-3802-3834',
    website: 'https://ryukyutouki-masahirokoubou.com',
    instagram: 'masahiro_koubou',
    lat: 26.4503,
    lng: 127.9261,
    featured: true
  },
  {
    id: '9',
    name: '居酒屋守礼',
    nameEn: 'Izakaya Shurei',
    category: 'Food',
    area: '那覇市首里',
    catchphrase: '地元に愛される居酒屋',
    description: '那覇市首里で地元の人々に愛され続けている居酒屋。沖縄の伝統料理から創作料理まで、豊富なメニューが揃っています。地元の食材を使った料理と、泡盛や沖縄のクラフトビールとの相性は抜群。アットホームな雰囲気の中で、琉球の食文化を存分に楽しめます。',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20traditional%20Japanese%20izakaya%20interior%20with%20wooden%20counter%20and%20tables%20featuring%20Okinawan%20dishes%20and%20awamori%20bottles%20displayed%20on%20shelves%20in%20warm%20ambient%20lighting%20with%20red%20lanterns%20and%20traditional%20decorations%20creating%20a%20welcoming%20atmosphere%20simple%20clean%20background&width=800&height=600&seq=shop9food&orientation=landscape',
    address: '〒903-0806 沖縄県那覇市首里汀良町１丁目２９',
    hours: '16:00 - 23:00',
    closed: '日曜日',
    phone: '098-885-4467',
    website: '',
    instagram: 'izakaya_shurei',
    lat: 26.2184,
    lng: 127.7233,
    featured: true
  }
];